<div class="container">
  <div class="content-wrapper" #wrapper>
    <img class="logo" src="/assets/images/transend-logo-title.png" alt="Transend">

    <div class="title">Command Center Change Password</div>
    <div class="sub-title"></div>

    <!-- Show error message if any -->
    @if (errorMessage) {
      <div class="error-message">
        {{ errorMessage }}
        <div class="actions">
          <button mat-flat-button color="primary" routerLink="/forgot-password">Reset Password</button>
          <button mat-flat-button color="accent" routerLink="/">Return to Login</button>
        </div>
      </div>
    }

    <!-- Show loading on is loading and no error -->
    @if (isLoading && !errorMessage) {
      <div class="loading-wrapper">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      </div>
    }

    <!-- Show form on done loading and no error -->
    @if (!isLoading && !errorMessage) {
      <div class="form-wrapper">
        <form [formGroup]="resetForm" class="signup-form">
          <!-- Email Field -->
          <div class="form-field">
            <label class="field-label" for="email-input">Email</label>
            <mat-form-field appearance="fill" hideRequiredMarker>
              <input matInput formControlName="email" type="email" readonly class="form-input" id="email-input" />
              @if (resetForm.get('email')?.errors?.['required']) {
                <mat-error>Email is required</mat-error>
              }
              @if (resetForm.get('email')?.errors?.['email']) {
                <mat-error>Invalid email</mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Password Field -->
          <div class="form-field">
            <label class="field-label" for="password-input">Password</label>
            <mat-form-field appearance="fill" hideRequiredMarker>
              <input matInput formControlName="password" type="password" class="form-input" id="password-input"
                appPasswordViewer #passwordViewer="passwordViewer" />
                <app-password-toggle-button matSuffix [passwordViewer]="passwordViewer"></app-password-toggle-button>
              </mat-form-field>
              @if (resetForm.get('password')?.touched && resetForm.get('password')?.invalid) {
                <mat-error class="mat-errors"
                  >
                  @if (resetForm.get('password')?.hasError('required')) {
                    <div>
                      Password is required.
                    </div>
                  }
                  @if (resetForm.get('password')?.hasError('minlength')) {
                    <div>
                      Password must be at least 12 characters long.
                    </div>
                  }
                  @if (resetForm.get('password')?.hasError('maxlength')) {
                    <div>
                      Password must not exceed 128 characters.
                    </div>
                  }
                  @if (resetForm.get('password')?.hasError('uppercase')) {
                    <div>
                      Password must contain at least one uppercase letter.
                    </div>
                  }
                  @if (resetForm.get('password')?.hasError('lowercase')) {
                    <div>
                      Password must contain at least one lowercase letter.
                    </div>
                  }
                  @if (resetForm.get('password')?.hasError('digit')) {
                    <div>
                      Password must contain at least one digit.
                    </div>
                  }
                  @if (resetForm.get('password')?.hasError('special')) {
                    <div>
                      Password must contain at least one special character.
                    </div>
                  }
                  @if (resetForm.get('password')?.hasError('identical')) {
                    <div>
                      Password cannot have more than 2 identical characters in a row.
                    </div>
                  }
                </mat-error>
              }
            </div>
            <!-- Confirm Password Field -->
            <div class="form-field">
              <label class="field-label" for="confirmPassword-input">Confirm Password</label>
              <mat-form-field appearance="fill" hideRequiredMarker>
                <input matInput formControlName="confirmPassword" type="password" class="form-input"
                  id="confirmPassword-input" />
                  @if (resetForm.get('confirmPassword')?.errors?.['required']) {
                    <mat-error>Confirm Password is
                    required</mat-error>
                  }
                  @if (resetForm.get('confirmPassword')?.errors?.['passwordMismatch']) {
                    <mat-error>Passwords do not
                    match</mat-error>
                  }
                </mat-form-field>
              </div>
            </form>
            <div class="form-actions" mat-dialog-actions>
              <button mat-flat-button color="accent" [disabled]="resetForm.invalid || isSubmitting"
                (click)="changePassword()">
                @if (!isSubmitting) {
                  <span>Change Password</span>
                }
                @if (isSubmitting) {
                  <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
                }
              </button>
            </div>
          </div>
        }
      </div>
    </div>